import { Box, Typography, useTheme } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';
export type PortfoliosTabFatalErrorProps = {
  message?: string;
};

export const PortfoliosTabFatalError = ({
  message,
}: PortfoliosTabFatalErrorProps) => {
  const theme = useTheme();
  const { t } = useTranslation('portfolioTradingHub');

  return (
    <Box
      sx={{
        p: 2,
      }}
    >
      <Typography variant='labelSmall' sx={{ color: theme.color.negative }}>
        {t('portfoliosTab.fatalError', { message: message ?? '' })}
      </Typography>
    </Box>
  );
};
